export default function() {}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-shape/src/noop.js
// module id = 35
// module chunks = 0